import PropTypes from "prop-types";
import "./RecentViewSkeleton.css";

const RecentViewSkeleton = ({ count = 5 }) => {
  return (
    <ul className="recentsListWrapper">
      {Array.from({ length: count }).map((_, index) => (
        <li key={index} className="recentsList skeleton-item"></li>
      ))}
    </ul>
  );
};

RecentViewSkeleton.propTypes = {
  count: PropTypes.number,
};

export default RecentViewSkeleton;
